const shortToLongHex = (hex: string) => {
  const r = hex.substring(1, 2);
  const g = hex.substring(2, 3);
  const b = hex.substring(3);
  return `#${r}${r}${g}${g}${b}${b}`;
};

const getR = (c: string) => parseInt(c.substring(1, 3), 16);
const getG = (c: string) => parseInt(c.substring(3, 5), 16);
const getB = (c: string) => parseInt(c.substring(5), 16);

export const getRGB = (hex: string) => {
  if (hex.length === 4) {
    hex = shortToLongHex(hex);
  }

  return `rgb(${getR(hex)}, ${getG(hex)}, ${getB(hex)})`;
};

export const getRGBA = (hex: string, opacity: number) => {
  if (hex.length === 4) {
    hex = shortToLongHex(hex);
  }

  return `rgba(${getR(hex)}, ${getG(hex)}, ${getB(hex)}, ${opacity})`;
};
